import { Toaster } from 'sonner'
import * as React from 'react'

export const Toast = () => {
  const [mounted, setMounted] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <Toaster
      position="bottom-right"
      style={{
        position: 'fixed',
        zIndex: 9999,
      }}
    />
  )
}
